import { placeholderStrategy } from './placeholder_strategy';

// Grouping strategies available in CE. Status grouping is EE-only, so this is
// just the temporary placeholder until CE-available groupings exist.
export const strategies = [placeholderStrategy];
